"use strict";

exports.__esModule = true;

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolveAttachments = function resolveAttachments() {
  return function (paragraph) {
    for (var _iterator = paragraph.value.glyphRuns, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var glyphRun = _ref;
      var _glyphRun$attributes = glyphRun.attributes,
          font = _glyphRun$attributes.font,
          attachment = _glyphRun$attributes.attachment;

      if (!attachment) continue;
      var objectReplacement = font.glyphForCodePoint(0xfffc);
      for (var i = 0; i < glyphRun.length; i++) {
        var glyph = glyphRun.glyphs[i];
        var position = glyphRun.positions[i];
        if (glyph === objectReplacement) {
          position.xAdvance = attachment.width;
        }
      }
    }

    return paragraph;
  };
};

exports.default = resolveAttachments;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-pdf/textkit-core/dist/layout/resolveAttachments.js
// module id = 862
// module chunks = 0